import { Navigate, Outlet, useLocation } from 'react-router'
import { usePlatformAuthStore } from '../store'

/**
 * The operator console's own guard.
 *
 * <p>Not {@code RequireAuth}: a signed-in tenant user must not reach these pages by knowing
 * the URL, and an operator has no tenant session to check. The two guards read two different
 * stores, which is what keeps that true.
 */
export function RequireOperator() {
  const operator = usePlatformAuthStore((state) => state.operator)
  const location = useLocation()

  if (!operator) {
    return <Navigate to="/platform/login" replace state={{ from: location.pathname }} />
  }
  return <Outlet />
}
